import { effect, inject } from "@angular/core";
import { Utilities } from "@itm/constants/utilities";
import moment from 'moment-timezone';

export abstract class BaseComponent {
    constructor(){
        effect(() => {
        })
    }

    checkImageFile(url: string): boolean {
        return /\.(png|jpg|jpeg|gif|bmp)$/i.test(url);
    }
    checkPdfFile(url: string): boolean {
        return /\.(pdf)$/i.test(url);
    }
    checkWordFile(url: string): boolean {
        return /\.(doc|docx)$/i.test(url);
    }
    checkExcelFile(url: string): boolean {
        return /\.(xls|xlsx)$/i.test(url);
    }

    getFileExtension(fileName: string): string {
        return fileName.split('.').pop()?.toLowerCase() || '';
    }

    getContentType(url: string) {
        if(this.checkImageFile(url)){
            return `image/${this.getFileExtension(url)}`;
        }
        else if(this.checkPdfFile(url)){
            return `application/${this.getFileExtension(url)}`;
        }
        else if(this.checkWordFile(url)){
            return `application/vnd.openxmlformats-officedocument.wordprocessingml.document`;
        }
        else if(this.checkExcelFile(url)){
            return `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`;
        }
    }
        
    formatDateTime(dateTime: string | null | undefined): string {
        if (!dateTime) return ''; // Handle null/undefined values
        
        return moment(dateTime)
            .tz(Utilities.DEFAULT_TIMEZONE) // Change to your desired timezone
            .format(Utilities.FORMAT_FULL_DATETIME); // Desired format
    }
        
    formatDate(dateTime: string | null | undefined): string {
        if (!dateTime) return ''; // Handle null/undefined values
        
        return moment(dateTime)
            .tz(Utilities.DEFAULT_TIMEZONE) // Change to your desired timezone
            .format(Utilities.FORMAT_FULL_DATE); // Desired format
    }
}